export default __webpack_public_path__ + "static/media/step2-assessment-results.b1dc1ed7.gif";